import { Component, Inject } from '@angular/core';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { MatTabsModule } from '@angular/material/tabs';
import { EncryptionService } from 'src/app/service/encryption.service';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { StorageService } from 'src/app/service/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalValueService } from 'src/app/service/globalValue.service.';
import { LetsChatComponent } from "../lets-chat/lets-chat.component";
import { DataService } from 'src/app/service/data.service';
import { ConstantService } from 'src/app/service/constant.service';

@Component({
    selector: 'app-knowledgeBase-SubCategory',
    standalone: true,
    templateUrl: './knowledge-base-subCategory.component.html',
    styleUrls: ['./knowledge-base-subCategory.component.less'],
    imports: [NgFor, NgIf,MatTabsModule, NgxPaginationModule, LetsChatComponent]
})

export class KnowledgeBaseSubCategoryComponent {

  selected = 0;
  p: number = 1;

  childItem = [];
  mainBaseArray = [];
  questionsArray = [];
  titleArrayForKeywords = [];  
  
  categoryID: string;
  subCategory: string;
  mainCategory: string;
  subCategoryId: string;
  categoryTitles: string;

  shimmer = false;

  constructor(
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private meta: Meta,
    private router: Router,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private storageService: StorageService,
    private constantService: ConstantService,
    private forumApiService: ForumApiService,
    private encryptionService: EncryptionService,
    private globalValueService: GlobalValueService    
  ) {}

  ngOnInit(): void {

    const url = this.router.url;
    let pathSegments;
    
    if (url) {
      pathSegments = url.split('/');
    } else {
      console.error('URL is undefined or null');
    }
    
    this.mainCategory = pathSegments[1];
    this.subCategory = pathSegments[2];

    this.dataService.data.subscribe((mainBaseArray) => {
      if(mainBaseArray.length > 0){
        mainBaseArray.forEach(mCategoryEle => {
          if(mCategoryEle.permalink === this.mainCategory) {
              this.childItem = mCategoryEle.child;
            }
        });
      }
      
        this.childItem.forEach(element => {
          if(element.permalink === this.subCategory){
            this.categoryID = element.id;
          }
        });
        this.getArticalList(this.categoryID);
        this.selectedMenuItem();
        this.addMetaTag();
    });
    
  }

  addMetaTag(): void {
    try{
      this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
      this.childItem.forEach((value) => { 
        this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + value.name;
        this.titleArrayForKeywords.push(value.name); 
       });
       var str = this.titleArrayForKeywords.join(", ");
       this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
       this.meta.updateTag({ name: this.constantService.keywords, content: str });
    }  catch(e){
      console.log('Error in addMetaTag method - ',e);
    } 
  }

  selectedMenuItem(): void {
    try{
      this.childItem.forEach((value, index) => {
        if(this.categoryID == value.id){
          this.selected = index;
          this.subCategoryId = value.id;
          this.titleService.setTitle(this.constantService.fivePaisaTextTitle + ' ' + value.name + ' ' + this.constantService.knowledgeBaseText);
        }
      });
    } catch(e){
      console.log('Error in selectedMenuItem method - ',e);
    }
  }  

  async getArticalList(catId: string): Promise<void> {
    try {
      this.shimmer = true;
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const categoryId = catId;
      const from = this.constantService.getArticleListRequestConstant.galFrom
      const limit = this.constantService.getArticleListRequestConstant.galLimit;
      const sortBy = this.constantService.getArticleListRequestConstant.galSortBy;
      const locale = this.constantService.getArticleListRequestConstant.gallocale;
      ;
    
      await this.forumApiService.articalList(portalId, categoryId, from, limit, sortBy, locale).then(async (getArticalListResponse) => {
        this.shimmer = false;
        this.categoryTitles = '';
        for(let i=0; i<getArticalListResponse.data.length; i++){
          this.questionsArray[i] = getArticalListResponse.data[i];
          this.categoryTitles = this.categoryTitles==undefined?"":this.categoryTitles + " " + getArticalListResponse.data[i].title;
          this.meta.updateTag({ name: this.constantService.description, content: this.categoryTitles});
        }
      });
    } catch (e) {
      this.shimmer = false;
      console.group('Error Occured in getArticalList : ', e);
    }
  }

  changeMenu(tabEvent: any): void {
    try{
      this.p = 1;
      this.titleService.setTitle(this.constantService.fivePaisaTextTitle + ' ' + tabEvent.tab.textLabel + ' ' + this.constantService.knowledgeBaseText);
      this.childItem.forEach((value) => {      
        if(tabEvent.tab.textLabel === value.name){
          this.questionsArray = [];
          this.getArticalList(value.id);
          this.subCategoryId = value.id;
          this.router.navigateByUrl(this.mainCategory + '/' + value.permalink);
          this.subCategory = value.permalink;
        }
      });
    } catch(e){
      console.log('Error in changeMenu method - ',e);
    }    
  }

  getValues(): { mainCategoryValue: any, subCategoryValue: any } {
    return {
      mainCategoryValue: this.globalValueService.mainCategory,
      subCategoryValue: this.globalValueService.subCategory
    };
  }

  setValues(value1: string, value2: string): void {
    try {
      this.globalValueService.mainCategory = value1;
      this.globalValueService.subCategory = value2;
    } catch(e){
      console.log('Error in setValues method - ',e);
    }
  }

  goTosubCategoryAnswers(questionId: string, questionTitle: string, subCatId: string): void {
    try{
      if(localStorage.getItem(this.constantService.isLoggedIn) == this.constantService.yes){
        const values = this.getValues();
        this.setValues(values.mainCategoryValue,subCatId);
      }
      this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
    } catch(e){
      console.log('Error in goTosubCategoryAnswers method - ',e);
    }
  }

}